const detectBrowser = () => {
  const userAgent = window.navigator.userAgent;
  const isEdge = /Edge/.test(userAgent);
  let currentBrowser = '';

  if (/Edge/.test(userAgent)) {
    currentBrowser = 'edge';
  } else if (/chrome/i.test(userAgent) && !isEdge) {
    currentBrowser = 'chrome';
  } else if (/safari/i.test(userAgent) && !isEdge) {
    currentBrowser = 'safari';
  } else if (/mobile/i.test(userAgent)) {
    currentBrowser = 'mobile';
  } else {
    currentBrowser = 'none';
  }

  if (currentBrowser) {
    document.body.classList.add(currentBrowser);
    document.documentElement.classList.add(currentBrowser);
  }

  return currentBrowser;
};

const detectOS = () => {
  const userAgent = window.navigator.userAgent;
  const platform =
    window.navigator?.platform || window.navigator?.userAgentData?.platform;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'macOS'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = '';

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'mac';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'ios';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'windows';
  } else if (/Android/.test(userAgent)) {
    os = 'android';
  } else if (/Linux/.test(platform)) {
    os = 'linux';
  }

  if (os) {
    document.body.classList.add(os);
    document.documentElement.classList.add(os);
  }

  return os;
};

window.addEventListener('DOMContentLoaded', () => {
  detectBrowser();
  detectOS();
});
